export default {
  data() {
    return {
      showItems: true,
      hiddenPhotos: [],
    }
  },
  computed: {
    isEditableState() {
      let isEditableState = false;

      if (this.album) {
        isEditableState = this.album.allow_clipping && +this.album.allow_clipping || this.album.allow_filters && +this.album.allow_filters
      }

      return isEditableState;
    },
    sizes() {
      const variant = this.myOrder.productItem ? this._.find(this.myOrder.productItem.variants,
          {id: this.myOrder.productVariantId}) : false;

      if (variant && variant.width && variant.height) {
        return {
          width: variant.width,
          height: variant.height,
        };
      }

      return {
        width: null,
        height: null,
      };
    },
    variant() {
      return this.myOrder.productItem ? this._.find(this.myOrder.productItem.variants, {
        id: this.myOrder.productVariantId
      }) : null;
    },
    isDeletableState() {
      return this.variant && this.variant.photos_limit_from
          ? +this.variant.photos_limit_from < this.myOrder.photos.length
          : true;
    },
  },
  watch: {
    myOrderPhotos() {
      if (this.completedDrawing) {
        this.hiddenPhotos.push(this.completedDrawing.photo);

        setTimeout(() => {
          this.hiddenPhotos = [];
          this.$store.dispatch('SET_COMPLETED_DRAWING', null);
        });
      } else {
        this.showItems = false;

        setTimeout(() => {
          this.showItems = true;
        });
      }
    },
  },
  methods: {
    getIndexById(id) {
      return this._.findIndex(this.myOrder.photos, {id});
    },
    chooseMorePhotosBtn() {
      const btn = document.getElementById('chooseMorePhotosBtn');
      btn && btn.click();
    },
    showPhotoEditor(photo, sizes) {
      if (+sizes.height === 0) {
        const dimensions = JSON.parse(photo.dimensions);
        sizes.height = parseInt(+sizes.width * +dimensions.height / +dimensions.width);
      }

      this.$store.dispatch('SET_DRAWING', {photo, sizes});
    },
    removePhoto(i) {
      const order = this.myOrder;
      order.photos.splice(i, 1);
      this.recount(order);
    },
    recount(order) {
      order.quantity = Object.values(order.photos).
          reduce((previous, {quantity}) => previous + quantity, 0);

      this.$store.dispatch('SET_ORDER', order);
    }
  },
  created() {
    this.$store.dispatch('SET_CAROUSEL_VIEW', null);
    this.recount(this.myOrder);
  }
};
